<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="">
        <h5 class="modal-title d-flex align-items-center">
          Push Rates & Availability
          <app-page-help articleId="x7j62kmrns" videoId="vME7vbq4DE0" class="ml-2"></app-page-help>
        </h5>
      </div>
      <div class="btn-holder text-right">
        <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
          <span class="fal fa-times"></span>
          Cancel
        </button>
        <button
          (click)="onPushRate()"
          type="button"
          [disabled]="!getSelected()?.length"
          class="btn btn-success text-uppercase ml10"
        >
          <span class="fas fa-arrow-up"></span>
          PUSH MAPPED RATES
        </button>

        <button
          (click)="onPushAvailability()"
          type="button"
          [disabled]="!getSelected()?.length"
          class="btn btn-success text-uppercase ml10"
        >
          <span class="fal fa-calendar-day"></span>
          PUSH AVAILABILITY
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-auto">
          <span class="select-channels">Select Channels</span>
        </div>
      </div>

      <div class="row">
        <div class="col-auto">
          <form [formGroup]="channelFiltersForm" class="channel-form">
            <div class="channel-checkbox">
              <mat-checkbox formControlName="all">
                <strong>All Channels</strong>
              </mat-checkbox>
            </div>
            <div *ngFor="let channel of channels$ | async" class="channel-checkbox">
              <mat-checkbox [formControlName]="channel.name">
                <img [src]="channel.logoColor" [alt]="channel.name" />
              </mat-checkbox>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="rental-box">
            <div class="table-header">
              <div class="table-title">
                <h6 class="d-flex align-items-center">
                  Available Rentals - {{ dataSource.data?.length }}
                  <span class="selected-rentals-count d-inline-flex align-items-center">
                    <span class="dot">&middot;</span>
                    &nbsp;&nbsp;
                    {{ getSelected().length }}/{{ dataSource.data?.length }} rentals selected
                  </span>
                </h6>
              </div>
              <div class="table-search">
                <app-table-search (search)="onSearch($event)" [hideClearFilterBtn]="true"></app-table-search>
              </div>
            </div>
            <div class="table-holder table-responsive">
              <table class="table table-default table-striped">
                <mat-table
                  #table
                  matSort
                  matSortActive="channelName"
                  matSortDirection="asc"
                  (matSortChange)="onSort($event)"
                  [dataSource]="dataSource"
                  multiTemplateDataRows
                >
                  <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                      >
                      </mat-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                      <div *ngIf="!row.isDoable" class="expandable-control">
                        <i
                          class="fal fa-exclamation-triangle text-warning"
                          [matTooltip]="getItemWarningInfo | call : row"
                          matTooltipPosition="right"
                        ></i>
                      </div>
                      <mat-checkbox
                        *ngIf="row.isDoable"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                      ></mat-checkbox>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="rentalName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Rental Name</mat-header-cell>
                    <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                      <div *ngIf="element.isLinked; else link" (click)="onRentalClick(element)">
                        <span
                          [matTooltip]="element.rentalName"
                          matTooltipPosition="above"
                          matTooltipClass="text-center"
                          class="text-truncate"
                        >
                          <app-rental-image
                            [rental]="element.rental"
                            [size]="35"
                            *ngIf="element.rental"
                          ></app-rental-image>
                          {{ element.rentalName }}
                        </span>
                      </div>
                      <ng-template #link>
                        <button
                          (click)="onLink(element)"
                          class="btn btn-success text-uppercase inline-btn"
                          type="button"
                        >
                          <i class="fal fa-link"></i>
                          Link
                        </button>
                      </ng-template>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="rentalAddress">
                    <mat-header-cell *matHeaderCellDef>country</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <span
                        [matTooltip]="element.rentalAddress"
                        matTooltipPosition="above"
                        matTooltipClass="text-center"
                        class="text-truncate"
                        >{{ element.rentalAddress }}</span
                      >
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="channelName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>channel</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <span class="channel_logo">
                        <img [src]="element.channel?.logoColor" [alt]="element.channelName" />
                      </span>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="propertyName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Property</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <span
                        [matTooltip]="element.propertyName"
                        matTooltipPosition="above"
                        matTooltipClass="text-center"
                        class="text-truncate"
                        >{{ element.propertyName }}</span
                      >
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div [ngSwitch]="element.status" class="status-icons">
                        <div *ngSwitchCase="'requesting'"><i class="far fa-spin fa-spinner text-primary"></i></div>
                        <div *ngSwitchCase="'scheduled'"><i class="far fa-clock text-warning"></i></div>
                        <div *ngSwitchCase="'done'">
                          <i class="far fa-check text-success" matTooltip="Done" matTooltipPosition="above"></i>
                        </div>
                        <div *ngSwitchCase="'error'">
                          <i
                            class="far fa-times text-danger"
                            [matTooltip]="element.errorText"
                            matTooltipPosition="above"
                          ></i>
                        </div>
                        <div *ngSwitchDefault>
                          <div
                            *ngIf="element.isRateMappingImplicit"
                            matTooltip="Tokeet is using a Default rate mapping."
                            style="font-size: 12px; font-weight: normal"
                          >
                            Auto Mapped
                          </div>
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="expandCtrl">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                      <div *ngIf="isExpandableRow | call : 0 : row" class="expandable-control">
                        <i *ngIf="row.id !== expandedRowItem?.id" class="far fa-chevron-right"></i>
                        <i *ngIf="row.id === expandedRowItem?.id" class="far fa-chevron-down"></i>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <mat-cell *matCellDef="let detail" [attr.colspan]="displayedColumns.length">
                      <app-rate-mappings-table
                        [rental]="detail.rental"
                        [rateMappings]="detail.rateMappings"
                        [connectionId]="detail.id"
                      ></app-rate-mappings-table>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [ngClass]="{ expanded: expandedRowItem?.id == row.id }"
                    (click)="onItemClick(row)"
                    class="element-row"
                  ></mat-row>

                  <mat-row
                    *matRowDef="let row; columns: ['expandedDetail']; when: isExpandableRow"
                    class="detail-row"
                    [class.expanded]="expandedRowItem && row.id == expandedRowItem.id"
                  ></mat-row>
                </mat-table>

                <mat-paginator
                  #paginator
                  [length]="dataSource?.filteredData?.length"
                  [class.hidden]="isEmptyTable$ | async"
                  [pageSize]="savedPageSize"
                  [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
                  [showFirstLastButtons]="true"
                >
                </mat-paginator>

                <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
